import type { ReactNode } from 'react';

/**
 * PageTitle — consistent page header across authenticated surfaces.
 *
 * Replaces ad-hoc `<h1 className="text-2xl">` usages (and pages that had no
 * heading at all) with one component, so heading size and the
 * title-with-trailing-actions layout are uniform. Token-driven sizing only.
 */
interface PageTitleProps {
  children: ReactNode;
  /** Optional trailing controls aligned to the right of the title (e.g. Export). */
  actions?: ReactNode;
}

export function PageTitle({ children, actions }: PageTitleProps) {
  return (
    <div className="flex items-center justify-between gap-3" data-slot="page-title">
      <h1 className="text-2xl text-[var(--text-primary)]">{children}</h1>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
